/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import styled from 'styled-components';

import Button from 'shared/components/presentational/Button';
import pxInRem from 'shared/helpers/styled-components/remHelper';
import BaseSelect from 'shared/components/presentational/Select';
import mediaQueries from 'shared/helpers/styled-components/mediaQueries';
import { FONT_FAMILIES, FONT_WEIGHTS } from 'shared/constants/theme';

/*
 * Main wrapper should be a section
 * in order to inherit margins
 */
export const Wrapper = styled.section`
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  background-color: var(--surface-primary);
  padding: 40px 20px 40px;
  ${mediaQueries.toTablet`
    margin-left: 15px;
    margin-right: 15px;
  `};
  ${mediaQueries.toPhablet`
    margin-left: 7px;
    margin-right: 7px;
    padding: 30px 40px;
  `};
`;

export const Select = styled(BaseSelect)`
  flex-basis: 240px;
  width: 240px;
  ${mediaQueries.toPhablet`
    flex-basis: 40px;
    width: 235px;
  `};
  .VirtualizedSelectOption {
    padding: 16px 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
  }
`;

export const StyledButton = styled(Button)`
  flex-basis: 240px;
  ${mediaQueries.toPhablet`
    flex-basis: 40px;
    width: 235px;
  `};
`;

export const Heading = styled.div`
  padding-bottom: 30px;
  ${mediaQueries.toPhablet`
    padding: 0 20px 20px;
  `};
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${pxInRem(14)};
  ${mediaQueries.toPhablet`
    flex-direction: column;
  `};
`;

export const ButtonIcon = styled(Button.children.SvgIcon)`
  margin-right: 4px;
`;

export const GeolocationButtonText = styled(Button.children.Text)`
  font-weight: ${FONT_WEIGHTS.normal};
`;

export const Or = styled.span`
  font-family: ${FONT_FAMILIES.brand};
  margin: 15px 30px;
  text-align: center;
`;
